import React, { useEffect, useState } from 'react';
import { locationGrey, NoAddress } from '../../assets/images';
import { Card, EmptyListCard, SpinnerDotted } from '../common/atoms';
import { handleAppError } from '../handlers';
import UserLocationModal from '../preEmployeeCheckup/UserLocationModal';
import { getGeoLocationByLatLng } from '../../services/GoogleMaps/google_map_apis';
import LocationManager from '../../managers/LocationManager';

const ChooseAddressModal = ({ employeeID, chooseAddressHandler }) => {
  const [state, setState] = useState({
    loading: true, employeeID: employeeID,
    benefitType: 'ahc', addresses: [], location: ''
  })

  const setSubState = (newState) => {
    setState(prevState => { return { ...prevState, ...newState } })
  }

  const fetchAddresses = () => {
    if (state.employeeID != null) {
      let url = window.API_URL + "corporate/customers/" + state.employeeID + "/addresses?company_id=" + sessionStorage.getItem('company_id') 
      window.axios.get(url)
        .then(function (response) {
          setSubState({ addresses: response.data.addresses, loading: false })
        })
        .catch(function (error) {
          handleAppError(error)
        })
    }
  }

  const addressHandler = (address) => {
    chooseAddressHandler(address, 'existing-address')
  }

  const setLocation = async (location) => {
    setSubState({ location: location })
    const { lat, lng } = location
    const geoLocation = await getGeoLocationByLatLng(lat, lng)
    if (!_.isEmpty(geoLocation) && geoLocation.length > 0) {
      setSubState({
        geoLocations: geoLocation[0]
      })
      const locationManager = new LocationManager(geoLocation[0])
      const address = locationManager.getFormattedAddress()
      address['latitude'] = lat
      address['longitude'] = lng
      setSubState({ address: address })
      chooseAddressHandler(address, 'new-address')
    }
  }

  useEffect(() => {
    fetchAddresses()
  }, [])

  const { addresses, loading } = state

  const renderSavedAddresses = () => {
    return(
      <>
      <div className='text-xs font-semibold tracking-widest leading-3 text-gray-500 mb-3 mt-6'>SAVED ADDRESSES</div>
      {addresses.map((item, index) => {
        return <Card
          key={item + index}
          svgsrc={locationGrey}
          title={item.address_tag}
          subTitle={`${item?.line1 ? item?.line1 + ',' : ''} ${item?.line2 ? item?.line2 + ',' : ''} ${item?.locality ? item?.locality + ',' : ''} ${item.city ? item?.city : ''}`}
          subText={`PIN: ${item.zip_code} `}
          classes='border-gray-200 bg-white mb-3 hover:bg-gray-50'
          svgClasses='h-7'
          clickable={true}
          handler={() => addressHandler(item)}
        />
      })}
      </>
    )
  }

  const renderNoSavedAddressCard = () => {
    return <EmptyListCard
            svgsrc={NoAddress}
            classes='mt-16'
            title='No saved address'
            subTitleClasses='w-72'
            subTitle="You don't have any saved addresses. Adding addresses helps you checkout faster"
            />
  }

  return (
    <div className=' pt-6 flex-column justify-between px-6' style={{ background: '#F9FAFB' }}>
      <div className=''>
        <div className='text-xs font-semibold tracking-widest leading-3 text-gray-500 mb-3'>SEARCH NEW LOCATION</div>
        <UserLocationModal
          customerId={state.employeeID}
          onSet={setLocation}
          addressValue={state.location.address}
          benefitType='ahc'
          placeholder='Search for a new location'
          inputClasses=' rounded-md hover:border-gray-300'
          inputStyle={{ borderWidth: '2px' }}
          dropdownStyle={{ position: 'absolute', zIndex: '2000', width: '100%' }}
          dropdownClasses='shadow-2xl' />
      </div>
      <div>
        
        { loading ? 
        <div className='flex justify-center items-center mt-20'>
          <SpinnerDotted classes='m-auto' />
        </div> :
         (addresses.length) > 0 ? renderSavedAddresses() : renderNoSavedAddressCard()
        }
      </div>
    </div>

  )
}

export default ChooseAddressModal;